import { Select } from "antd";
import React from "react";
const CustomDataType = (
    field = {},
    handleOnChange = () => { },
    errors = {}, data = {},
    ImageList = [] // Add errors as a parameter
) => {
    return <div >
        {field && field.DataType && field.DataType === 'Image' ?
            <div >
                <Select showSearch placeholder="Select Standard Type..." onChange={(value) => {
                    handleOnChange({ target: { name: field.DbFieldName, value: value } })
                }} value={data[field.DbFieldName] || []} style={{ width: "100%" }}>
                    {ImageList && ImageList.map((one) => {
                        return <Select.Option value={one._id}>{one.DocTitle}</Select.Option>
                    })}
                </Select>
                {/* <select
                    className=" text-center form-control form-control-sm p-0"
                    id={field.FieldName}
                    name={field.DbFieldName}
                    value={data[field.DbFieldName] && data[field.DbFieldName].DocTitle || ""}
                    onChange={handleOnChange}
                >

                    {ImageList && ImageList.map((item) => <option value={item._id}>{item.DocTitle} </option>)}
                </select> */}
                {!data[field.FieldName] && <div className="invalid-feedback animated fadeInUp" style={{ display: "block" }}>
                    {errors[field.FieldName] && errors[field.FieldName]}
                </div>}
            </div> : <div><textarea
                type="text "
                className="form-control form-control-sm p-0 text-center"
                id={field.FieldName}
                value={data[field.DbFieldName] || ""}
                name={field.DbFieldName}
                onChange={handleOnChange}
            // value={field.constantValue}
            />
                {!data[field.DbFieldName] && <div className="invalid-feedback animated fadeInUp" style={{ display: "block" }}>
                    {errors[field.DbFieldName] && errors[field.DbFieldName]}
                </div>}
            </div>}
    </div>
    switch (field.DataType) {
        case 'NumberInput':
            return (
                <div >
                    <input
                        type="number"
                        className="form-control form-control-sm p-0"
                        id={field.FieldName}
                        name={field.FieldName}
                        placeholder={field.placeholder || ''}
                        onChange={handleOnChange}
                        value={data[field.FieldName] || ""}
                    />
                    {!data[field.FieldName] && <div className="invalid-feedback animated fadeInUp" style={{ display: "block" }}>
                        {errors[field.FieldName] && errors[field.FieldName]}
                    </div>}
                </div>
            );

        case 'UserInputDecision':
            return (
                <div >
                    <select
                        className="form-control form-control-sm p-0"
                        id={field.FieldName}
                        name={field.FieldName}
                        value={data[field.FieldName] || ""}
                        onChange={handleOnChange}
                    >
                        <option value="">Select an option</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                    {!data[field.FieldName] && <div className="invalid-feedback animated fadeInUp" style={{ display: "block" }}>
                        {errors[field.FieldName] && errors[field.FieldName]}
                    </div>}
                </div>
            );

        case 'InputString':
            return (
                <div >
                    <input
                        type="text"
                        className="form-control form-control-sm p-0"
                        id={field.FieldName}
                        name={field.FieldName}
                        value={data[field.FieldName] || ""}
                        placeholder={field.placeholder || ''}
                        onChange={handleOnChange}
                    />
                    {!data[field.FieldName] && <div className="invalid-feedback animated fadeInUp" style={{ display: "block" }}>
                        {errors[field.FieldName] && errors[field.FieldName]}
                    </div>}
                </div>
            );

        case 'ConstantString':
            return (
                <div >
                    <input
                        type="text"
                        className="form-control form-control-sm p-0"
                        id={field.FieldName}
                        value={data[field.FieldName] || ""}
                        name={field.FieldName}
                        onChange={handleOnChange}
                    // value={field.constantValue}
                    />
                    {!data[field.FieldName] && <div className="invalid-feedback animated fadeInUp" style={{ display: "block" }}>
                        {errors[field.FieldName] && errors[field.FieldName]}
                    </div>}
                </div>
            );

        case 'InputFromList':
            return (
                <div>
                    <select
                        className="form-control p-0"
                        id={field.FieldName}
                        value={data[field.FieldName] || ""}
                        name={field.FieldName}
                        onChange={handleOnChange}
                    >
                        <option value="">Select an option</option>
                        {field.options.map((option, index) => (
                            <option key={index} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {!data[field.FieldName] && <div className="invalid-feedback animated fadeInUp" style={{ display: "block" }}>
                        {errors[field.FieldName] && errors[field.FieldName]}
                    </div>}
                </div>
            );

        case 'StandardNumber':
            return (
                <div >
                    <input
                        type="number"
                        value={data[field.FieldName] || ""}
                        className="form-control form-control-sm p-0"
                        id={field.FieldName}
                        name={field.FieldName}
                        placeholder={field.placeholder || ''}
                        onChange={handleOnChange}
                    />
                    {!data[field.FieldName] && <div className="invalid-feedback animated fadeInUp" style={{ display: "block" }}>
                        {errors[field.FieldName] && errors[field.FieldName]}
                    </div>}
                </div>
            );

        case '+ToleranceNumber':
            return (
                <div >
                    <input
                        type="number"
                        value={data[field.FieldName] || ""}
                        className="form-control form-control-sm p-0"
                        id={field.FieldName}
                        name={field.FieldName}
                        placeholder={field.placeholder || '+ Tolerance'}
                        onChange={handleOnChange}
                    />
                    {!data[field.FieldName] && <div className="invalid-feedback animated fadeInUp" style={{ display: "block" }}>
                        {errors[field.FieldName] && errors[field.FieldName]}
                    </div>}
                </div>
            );

        case '-ToleranceNumber':
            return (
                <div >
                    <input
                        type="number"
                        value={data[field.FieldName] || ""}
                        className="form-control form-control-sm p-0"
                        id={field.FieldName}
                        name={field.FieldName}
                        placeholder={field.placeholder || '- Tolerance'}
                        onChange={handleOnChange}
                    />
                    {!data[field.FieldName] && <div className="invalid-feedback animated fadeInUp" style={{ display: "block" }}>
                        {errors[field.FieldName] && errors[field.FieldName]}
                    </div>}
                </div>
            );

        default:
            return <></>;
    }
};

export default CustomDataType;
